<template>
  <div class="container">
    <div class="uk-text-left">
      <h4 class="title uk-margin-remove">
        Planeación y Seguimiento de la Cadena de Frío de Productos Perecederos
      </h4>
      <h5 class="subtitle uk-margin-remove">
        Paso 1: Suministre Compañía, Categoría y Producto
      </h5>
      <div class="uk-padding-remove">
        <form class="title-main   uk-form-stacked uk-text-left uk-margin">
          <div class="filter">
            <label
              class="labeltext"
              for="form-stacked-text"
            >
              Compañía <span>*</span>
            </label>
            <div class="uk-form-controls">
              <input
                id="form-horizontal-text"
                v-model="productInfo.companyName"
                class="uk-input"
                type="text"
                placeholder="Compañía"
              >
            </div>
          </div>
          <loading
            :active="isLoading"
            :is-full-page="true"
          />
          <div class="filter">
            <label
              class="labeltext"
              for="form-stacked-select"
            >Categoría <span>*</span>
            </label>
            <div class="uk-form-controls">
              <select
                id="form-horizontal-select"
                v-model="productInfo.category"
                class="uk-select"
                @change="resetProducts"
              >
                <option disabled>
                  Seleccione Categoría
                </option>
                <option
                  v-for="i in categories"
                  :key="i"
                  :value="i.id"
                >
                  {{ i.description }}
                </option>
              </select>
            </div>
          </div>
          <div class="filter">
            <label
              class="labeltext"
              for="form-stacked-select"
            >Producto <span>*</span>
            </label>
            <div class="uk-form-controls">
              <Multiselect
                v-model="productInfo.products"
                :options="productsCategory"
                mode="tags"
                :searchable="true"
                @change="resetSelectionCategory"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div>
      <div class="uk-position-relative">
        <div
          v-if="isContentBlocked"
          class="blocked-content"
        />
        <div class="subtitle ">
          Paso 2: Construya su Cadena de Frío
          <p class="helper">
            <strong class="helper">Instrucciones:</strong> Elija su Tipo de Cadena de Frío, y luego arrastre los elementos que aparecen en el panel de la izquierda hacia el área de diseño en la derecha. Puede reorganizar los elementos en el área de diseño arrastrándolos en el orden deseado. También puede entrar un nombre y una imagen para sustituir los valores por defecto.
          </p>
        </div>
        <h4
          v-if="currentColdChain.length === 0"
          class="uk-text-center uk-text-bold title uk-padding-remove"
        >
          Construya Su Cadena de Frío Según Le Mostramos Aquí
        </h4>

        <div class="container-main">
          <div class="uk-section draggable-main">
            <aside class="aside">
              <div>
                <h4 class="subtitle uk-padding-remove">
                  Pasos Cadena de Frío
                </h4>
                <div class="uk-form-controls">
                  Tipo de Cadena de Frío
                  <select
                    id="form-horizontal-select"
                    v-model="chainType"
                    class="uk-select"
                    style="margin-top: 5px;"
                    @change="removeChain"
                  >
                    <option
                      v-for="i in coldChainTypes"
                      :key="i.id"
                      :value="i.id"
                    >
                      {{ i.description }}
                    </option>
                  </select>
                </div>
                <hr>
                <draggable
                  class="typeColdChain"
                  :list="currentChain"
                  :group="
                    { name:'people' ,
                      pull:'clone',
                      put:false
                    }"
                  :clone="handleClone"
                  :sort="false"
                >
                  <div
                    v-for="item in currentChain"
                    :key="uuid(item)"
                    class="btn-drop"
                  >
                    <span
                      :style="{ background: item.backgroundColor }"
                      class="btn-drop-item"
                      href="#"
                    >
                      <span
                        class="description-step"
                        :style="{ color: item.textColor }"
                      >{{
                        item.description
                      }}</span>
                    </span>
                  </div>
                </draggable>
              </div>
            </aside>
            <div class="main">
              <div>
                <h4>Cadena de Frío {{ currentChainDescription }}</h4>
              </div>
              <div>
                <draggable
                  :class="{'drop-zone': !isContentBlocked}"
                  :list="currentColdChain"
                  group="people"
                  @change="log"
                >
                  <img
                    v-if="currentColdChain.length === 0"
                    src="../../assets/img/drag-video.gif"
                    class="img-gif"
                  >
                  <div
                    v-for="(item, $index) in currentColdChain"
                    v-else
                    v-show="!isContentBlocked"
                    :key="uuid(item)"
                    class="card"
                    :style="{ zoom: `${zoomDrag}%`}"
                  >
                    <div
                      :style="{ background: item.backgroundColor }"
                      class="tooltip"
                    >
                      <font-awesome-icon
                        class="font-icon"
                        icon="times"
                        @click="deleteItem(item)"
                      />
                      <span v-if="!item.tooltiptext">{{ item.description }}</span>
                      <span
                        v-else
                        class="titlemodified"
                      >{{ item.tooltiptext }}</span>

                      <input
                        v-model="item.tooltiptext"
                        type="text"
                        maxlength="16"
                        class="uk-input uk-form-width-small title-tooltiptext"
                      >
                      <label
                        :for="'upFile'+ $index"
                        class="upload"
                      >
                        <font-awesome-icon
                          icon="upload"
                          class="upload-icon"
                        />
                      </label>
                      <input
                        :id="'upFile'+ $index"
                        type="file"
                        style="display: none; visibility: none;"
                        @change="onFileChange($event, item)"
                      >
                      <div
                        v-if="$index != currentColdChain.length - 1"
                        class="line"
                      >
                        &#8594;
                      </div>
                    </div>
                    <span
                      :style="{ background: item.backgroundColor , width: zoomDrag }"
                      class="tooltiptext"
                    >
                      <h5
                        v-if="!item.tooltiptext"
                        class="uk-margin-remove"
                      >{{ item.description }}</h5>
                      <h5
                        v-else
                        class="titlemodified uk-margin-remove"
                      >{{ item.tooltiptext }}</h5>
                      <div>
                        <img
                          :src="item.image"
                        >
                      </div>

                      <p class="data">{{ item.info }}</p>
                    </span>
                  </div>
                </draggable>
              </div>
              <div
                v-if="currentColdChain.length > 0"
                class="uk-flex uk-flex-right uk-margin-remove"
              >
                <div class="uk-flex zoom-el">
                  <h5
                    disabled
                    class="title uk-margin-remove"
                  >
                    zoom: {{ zoomDrag }}
                  </h5>
                  <font-awesome-icon
                    class="zoom-out"
                    icon="search-minus"
                    @click="zoomDrag = zoomDrag - 5"
                  />
                  <font-awesome-icon
                    class="zoom-in"
                    icon="search-plus"
                    @click="zoomDrag = zoomDrag + 5"
                  />
                </div>
              </div>
              <div
                v-else
                style="margin: 18px 0px 5px 0px "
              >
                <h5 class="uk-margin-remove uk-text-meta">
                  Seleccione su tipo de cadena de frío y luego arrastre los pasos hacia el panel de la derecha para completar su cadena de  Frío
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn uk-flex uk-flex-right">
      <button
        :disabled="currentColdChain.length === 0 || (currentColdChain[currentColdChain.length -1].order <= 2)"
        class="uk-button"
        @click="pushPage('ReportColdChain')"
      >
        Continuar
      </button>
    </div>
  </div>
</template>

<script>
import { VueDraggableNext } from 'vue-draggable-next'
import Multiselect from '@vueform/multiselect'
import { mapGetters } from 'vuex'

export default {
  components: {
    Draggable: VueDraggableNext,
    Multiselect
  },
  data () {
    return {
      image: null,
      zoomDrag: 85,
      drag: false,
      itemDrag: false,
      items: [],
      counter: 5,
      condition: false,
      productsCategory: [],
      isLoading: false,
      productInfo: {
        companyName: null,
        category: null,
        products: []
      },
      currentColdChain: [],
      categories: [],
      coldChainTypes: [],
      chainType: null
    }
  },
  computed: {
    ...mapGetters([
      'productInfoStore',
      'coldChain',
      'storeChainType'
    ]),
    isContentBlocked () {
      return !(this.productInfo?.companyName &&
              this.productInfo?.products?.length > 0)
    },

    currentChain () {
      const currentCategory = this.categories.find(x => x.id === this.productInfo.category)
      const chains = this.coldChainTypes.find((x) => x.id === this.chainType)?.chains
      if (!chains) return []
      if (currentCategory != null && (currentCategory.description.indexOf('Aves') === -1 && currentCategory.description.indexOf('Carnes') === -1)) {
        return chains.filter(x => x.description.toUpperCase() !== 'MATADERO')
      } else {
        return chains.filter(x => x.description.toUpperCase() !== 'CAMPO/COSECHA')
      }
    },
    currentChainDescription () {
      return this.coldChainTypes.find(x => x.id === this.chainType)?.description
    },
    selectedProducts () {
      if (this.productInfo.products.length > 0) {
        return this.productsCategory.filter(x => this.productInfo.products.find(d => d === x.id))
      }
      return []
    }
  },
  watch: {
    productInfo: {
      handler: function (newVal) {
        this.$store.commit('setProductInfo', newVal)
      },
      deep: true
    },
    'productInfo.category': async function (newVal) {
      await this.getCategoriesProducts(newVal)
    },

    zoomDrag (newVal, oldVal) {
      if (this.zoomDrag > 120) this.zoomDrag = 120
      if (this.zoomDrag < 70) this.zoomDrag = 70
    }
  },
  async mounted () {
    this.productInfo = this.productInfoStore
    if (this.coldChain) {
      this.coldChain.forEach(element => {
        this.currentColdChain.push(element)
      })
    }

    try {
      this.isLoading = true
      this.categories = await this.$services.productCategoriesService.getCategories()
      this.coldChainTypes = await this.$services.coldChainTypeService.getAll()
      this.coldChainTypes.forEach(ct => ct.chains.forEach(c => {
        if (c.defaultImageUrl.indexOf('http://') > -1 || c.defaultImageUrl.indexOf('https://') > -1) {
          c.image = c.defaultImageUrl
        } else {
          c.image = require(`../../assets/img/${c.defaultImageUrl}`)
        }
      }))
      this.isLoading = false
    } catch (error) {
      this.isLoading = false
      this.$toast.warning('No se pudo obtener los datos, contáctese con su administrador.', {
        position: 'top',
        duration: 4000
      })
    }

    if (this.storeChainType === null) {
      this.chainType = 1
    } else {
      this.chainType = this.storeChainType
    }
  },
  methods: {
    removeChain () {
      this.currentColdChain = []
    },
    closeDrag (id, index) {
      const findedIndex = this.currentColdChain.findIndex((x) => x.id === id)
      if (index >= 0 && findedIndex === index) this.currentColdChain.splice(index, 1)
    },
    pushPage (name) {
      this.$store.commit('setColdChain', this.currentColdChain)
      this.productInfo.selectedProducts = this.selectedProducts
      this.productInfo = { ...this.productInfo, currentChainDescription: this.currentChainDescription }
      this.$store.commit('setProduct', this.productInfo)
      this.$router.push({ name })
      this.$windowPlugin.scrollToTop()
      this.$store.commit('setChainType', this.chainType)
    },
    add () {
    },
    replace () {
    },
    log (event) {
      const { moved, added } = event
      if (added) {
        this.addedNewItem(added)
      }
      if (moved) {
        this.movedItem(moved)
      }
    },
    addedNewItem (added) {
      if (this.currentColdChain.length === 1 && added.element.order !== 1) {
        this.currentColdChain.pop(added.newIndex)
        return
      }

      if (!this.$helperPlugin.addedOrderIsValidate(this.currentColdChain, added)) {
        this.$toast.warning('Esta relación no es correcta', {
          position: 'top',
          duration: 4000
        })
      }

      const lastElement = { ...this.currentColdChain[this.currentColdChain.length - 2] }
      if (added.element.order > 2 && lastElement.order !== 2 && lastElement.order !== added.element.order && added.element.description.toLowerCase() !== 'transporte') {
        this.currentColdChain.pop(this.currentColdChain.length - 1)
        const transport = { ...this.currentChain.find(x => x.description.toLowerCase() === 'transporte') }
        this.currentColdChain.push(transport)
        this.currentColdChain.push(added.element)
      }
    },
    movedItem (moved) {
      if (!this.$helperPlugin.orderIsValidate(this.currentColdChain, moved)) {
        this.$toast.warning('Esta relación no es correcta', {
          position: 'top',
          duration: 4000
        })
      }
    },
    handleClone (item) {
      // Create a fresh copy of item
      const cloneMe = JSON.parse(JSON.stringify(item))

      delete cloneMe.uid

      return cloneMe
    },

    deleteItem (item) {
      const index = this.currentColdChain.findIndex((x) => x.uid === item.uid)
      if (index >= 0) {
        this.currentColdChain.splice(index, 1)
      }
    },

    uuid (e) {
      if (e.uid) return e.uid
      const key = Math.random().toString(16).slice(2)

      e.uid = key
      return e.uid
    },
    async getCategoriesProducts (idCategories) {
      try {
        this.isLoading = true
        const products = await this.$services.productCategoriesService.getCategoriesProducts(idCategories)
        this.isLoading = false
        this.productsCategory = products.map(data => {
          return {
            ...data,
            value: data.id,
            label: `${data.description} ${data.subDescription ?? ''} `
          }
        })
      } catch (error) {
        this.isLoading = false
        console.log(error)
        this.$toast.warning('No se pudo obtener los datos, contáctese con su administrador.', {
          position: 'top',
          duration: 4000
        })
      }
    },
    onFileChange (e, item) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }

      this.createImage(files[0], item)
    },
    createImage (file, item) {
      const reader = new FileReader()
      reader.onload = (e) => {
        item.image = e.target.result
      }

      reader.readAsDataURL(file)
    },
    resetProducts () {
      this.currentColdChain = []
      this.productInfo.products = null
    },
    resetSelectionCategory () {
      if (this.productInfo.products) {
        this.currentColdChain = []
      }
    }
  }
}
</script>

<style scoped>
*{
  color: #333333;
}
.container {
  margin: 20px;

}
.btn-drop {
  margin: 10px 0px;
}

.subtitle {
  font-size: 14px;
  font-weight: bold;
  padding: 20px 0px 5px;
}

.draggable-main {
  padding: 20px 0px;
  display: flex;
  text-align: center;
}
.btn-drop-item {
  display: block;
  text-align: start;
  padding: 10px;
  cursor: grab;
}
.description-step{
  color: white
}
.container-main {
  margin: 20px 0px;
  box-shadow: 0px 0px 1px #000;
}
.labeltext {
  font-weight: bolder;
  font-size: 14px;
}
.labeltext span {
  color: red;
}
.aside {
  width: 22%;
  padding: 0px 20px;
}
.main {
  width: 70%;
  margin: 0px auto;
}
.container {
  margin: 20px;
}
.title-main{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.drop-zone {
  background: url('../../assets/img/grid3.jpg') , #fff ;
  box-shadow: 0px 0px 3px #000;
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;
  padding: 20px 30px;
  height: 360px;
  position: relative;
}
.drop-zone img{
  width: 700px;
  margin: auto
}

.tooltip {
  position: relative;
  padding-top: 19px;
  width: 145px;
  margin-right: 50px ;
  margin-bottom: 10px;
  height: 86px;
  border-radius: 5px;
  cursor: grab;
}
.tooltip span{
  color: #fff !important
}
.tooltip input{
  height: 20px;
  width: 80%;
  position: absolute;
  top: 60px;
  left: 7px
}
.tooltip .upload{
  position: absolute;
  top: 63px;
  right: 5px;
  width: 10%;
  height: 20%;
}
.tooltip .upload .upload-icon{
  color: #fff !important;
}
.tooltiptext {
  visibility: hidden;
  min-width: 165px !important;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0px;
  position: absolute;
  left: -10px;
  z-index: 1;
  width: 20%;
}

.tooltiptext h5{
  color: #fff !important;
  font-size: 14px;
  margin-bottom: 4px;
}

.tooltiptext img{
  width: 70px;
  height: 70px;
  margin: 0px auto;
}

.tooltiptext .data{
  color: #fff;
  margin: 5px;
  line-height: 1.3
}
.title-tooltiptext{
  text-transform: uppercase;
}
.titlemodified{
  text-transform: uppercase;
}
.card:hover .tooltiptext {
  visibility: visible;
}

.card{
  position: relative;
  height: 60%;
  margin-bottom: 20px;
  max-height: 50px;
}

form {
  margin: 1rem 0;
}

button {
  color: white;
}

.helper {
  color: rgb(131, 128, 128) !important;
  margin-top: 5px;
}

.blocked-content {
  background: white;
  opacity: 0.9;
  width: 100%;
  height: 100%;
  position: absolute;
}
.line {
  width: 33px;
  font-size: 50px;
  font-weight:900;
  position: absolute;
  left: 144px;
  color: rgb(204, 0, 0);
  top: 5px;
}

.font-icon {
  width: 9px;
  position: absolute;
  cursor: pointer;
  color: white;
  left: 130px;
  top: 1px;
  font-size: 17px;
}
.font-icon:hover {
  color: black;
}
.filter {
  margin-right: 10px;
  min-width: 150px;
  width: 30%;
}

.zoom-el{
  box-shadow: 0px 0px 4px #000;
  padding: 10px 5px;
  cursor:pointer
}

.zoom-in{
  margin: 3px 10px;
  font-size: 14px
}
.zoom-out{
  margin: 3px 15px;
  font-size: 14px

}
.img-gif{
 height: 290px;
}

@media screen and (max-width: 1100px){
  .img-gif{
    display: none;
  }
}
@media screen and (max-width: 900px){
.draggable-main{
  display: block
}
.filter{
  margin-top: 5px;
  min-width: 200px;
  flex-grow: 1;
  width: 40%;
}
.aside {
width: 100%;
margin: 0px auto;
}
 .main{
  width: 85%
}
.typeColdChain{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}
.description-step{
  font-size: 10px
}
.btn-drop {
  min-width: 95px;
  margin: 10px;
  flex-grow: 1;
}
.btn-drop-item{
  padding: 7px
}
.title{
  margin: 10px
}
}
@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }
  .subtitle{
    font-size: 12px
  }
  .labeltext {
  font-weight: bolder;
  font-size: 12px;
}
  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }
.opt{
    font-size: 10px;
  }
  .drop-zone {
    padding: 15px 10px;
  }
  .btn-drop-item{
  text-align: center;
}
.tooltiptext {
  padding: 5px 0px;
  left: -7px;
}

.tooltiptext h5{
  color: #fff !important;
  font-size: 10px;
  margin-bottom: 4px;
}

.tooltiptext img{
  width: 40%;
  height: auto;
  margin: 0px auto;
}

}
@media screen and (max-width: 504px){
  .drop-zone {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    height: 350px
  }

.card{
  height: 60%;
  max-height: 50px !important;
  margin: 0px auto 54px;

}
.title{
  text-align: center;
}
.subtitle{
  text-align: center;
}
.tooltip {
  margin: 0px ;
}
.line{
  width: 34px;
  left: 60px;
  top: 81px;
  transform: rotate(90deg);
  font-size: 19px;
}
.tooltiptext{
  margin-top: 5px
}

}
@media screen and (max-width: 380px){
  .filter{
    width: 100%
  }

}
</style>
<style
  src='../../../node_modules/@vueform/multiselect/themes/default.css'
></style>
